import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MenuItem, Message, MessageService } from 'primeng/api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { AdministracionService } from 'src/app/administracion/administracion.service';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { ContactosService } from 'src/app/contactos/contactos.service';
import { FAZILService, User, UserService } from 'src/app/core';
import { ResultData, UIService } from 'src/app/core/services/ui.service';
import { EmissionPoint } from 'src/app/modelo/EmissionPoint';
import { Establishment } from 'src/app/modelo/Establishment';
import { Retencion, RetencionDetalle } from 'src/app/modelo/Retencion';
import { Product } from 'src/app/modelo/Product';
import { Subject } from 'src/app/modelo/Subject';
import { SubjectCustomer } from 'src/app/modelo/SubjectCustomer';
import { ComprobantesService } from 'src/app/services/comprobantes.service';
import { DataService } from 'src/app/services/data.service';
import { ServiciosService } from 'src/app/servicios/servicios.service';
import { precisionRound, validateDni, validateDNIPattern, validateEmail, validateRUC } from 'src/app/shared/helpers';
import { environment } from 'src/environments/environment';
import { FacturasService } from '../facturas.service';
import { PaymentMethod } from 'src/app/modelo/PaymentMethod';
import { EstablecimientosService } from 'src/app/perfil/establecimientos/establecimientos.service';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { COMMA, ENTER, ESCAPE, SPACE, TAB } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatChipInput, MatChipInputEvent, MatChipList } from '@angular/material/chips';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { VeronicaApiSubErrorData } from 'src/app/modelo/VeronicaAPIErrorData';
import { SubjectCustomerOutput } from 'src/app/core/models/contacto.model';
import { PageOptions } from 'src/app/core/models/pagination';

@Component({
    selector: 'app-retencion-popup',
    templateUrl: './retencion-popup.component.html',
    styleUrls: ['./retencion-popup.component.scss']
})
export class RetencionPopupComponent implements OnInit {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    currentUser: User;
    retencion: Retencion = new Retencion();;
    details: RetencionDetalle[] = [];

    //Variables para contactos
    subjectCustomers: SubjectCustomer[] = [];
    subjectCustomersFiltered: SubjectCustomer[] = [];
    subjectCustomer: SubjectCustomer = new SubjectCustomer();
    mostrarPopupSubjectCustomers: boolean = false;
    mostrarEditorSubject: boolean = false;
    subject: Subject = new Subject();
    subjectCode: string;
    subjectNUI: string;
    subjectCodeValid: boolean = false;
    emailValid: boolean = false;
    searching = false;

    //Variables para productos
    products: Product[] = [];
    productsFiltered: Product[] = [];
    productTypes: any[] = [];
    productType: any;
    product: Product = new Product();
    productSelected: Product = new Product();
    mostrarPopupProducts: boolean = false;
    mostrarEditorProduct: boolean = false;
    ivaValor: number = this.appConfig.app.iva.factor / 100;
    iva12: boolean = true;

    //Variables para establecimientos
    establishments: Establishment[] = [];
    establishment: Establishment = new Establishment();
    emissionPointSelected: EmissionPoint = null;

    //Variables auxiliares
    isUnitDetail: boolean = true;
    exitenDetallesSeleccionados: boolean = false;

    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    processFilter = false;
    verificando: boolean = false;
    verificandoData: ResultData;
    resultData: ResultData;
    resultDataButtons: any[] = [];
    mostrarResultData: boolean = false;
    ui: UIService;

    paymentMethods: PaymentMethod[] = [];
    selectedPaymentMethod: PaymentMethod;

    //Help Section
    safeSrc: SafeResourceUrl;
    display: boolean;
    pageDescription: string;

    //Campos adicionales
    camposAdicionales: any[] = [];

    //Chips destinatarios
    separatorKeysCodes: number[] = [ENTER, COMMA, SPACE, TAB];
    destinatarioCtrl = new FormControl('');
    filtered: Observable<string[]>;
    destinatarios: string[] = [];
    destinatariosAll: string[] = [];
    @ViewChild('destinatarioInput') destinatarioInput: ElementRef<HTMLInputElement>;
    @ViewChild('auto') matAutocomplete: MatAutocomplete;

    //Catalgos para retención
    tiposDocumentosIdentidad: any[] = [];
    filtrados: any[] = [];

    tiposRetenciones: PaymentMethod[] = [];
    retenciones: PaymentMethod[] = [];
    codigosRetenciones: PaymentMethod[] = [];
    tiposComprobantes: PaymentMethod[] = [];


    //Para agregar/editar detalles de retencion
    detail: RetencionDetalle;
    mostrarPopupDetalleRetencion: boolean = false;

    fechaActual: Date = new Date();

    pageOptions: PageOptions = { page: 0, pageSize: 10, filter: '' };

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private fazilService: FAZILService,
        private uiService: UIService,
        private dataService: DataService,
        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService,
        private facturasService: FacturasService,
        private comprobantesService: ComprobantesService,
        private contactosService: ContactosService,
        private serviciosService: ServiciosService,
        private administracionService: AdministracionService,
        private establecimientosService: EstablecimientosService,
        private sanitizer: DomSanitizer,
    ) {
        this.ui = uiService;
        this.cargarDataConstructor();

        this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.appConfig.app.help.url);
        this.pageDescription = 'En esta opción usted puede realizar la emisión de una nueva retención para un cliente.';
    }

    cargarDataConstructor() {
        this.cargandoDataInit = true;
        this.route.data.subscribe((data) => {
            if (data['retencion']) {//Editar factura normal
                this.retencion = data['retencion'];
            }
        });
        this.breadcrumbService.setItems([
            { label: 'Retención', routerLink: ['facturas/retencion/retencion'] }
        ]);

        this.productTypes = this.appConfig.properties.productTypes;
    }

    ngOnInit(): void {
        this.userService.currentUser.subscribe(userData => {
            this.currentUser = userData;
            if (this.currentUser && this.currentUser.uuid) {
                if (this.currentUser.assistant.complete) {
                    this.cargarDataInit();
                } else {
                    this.fazilService.irAInicio(); //Mostrar el asistente
                }
            }
        });
    }

    async cargarDataInit() {
        
        //Cargar estabishments y emissionPoints con sus respectivas secuencais por tipo de combrobante
        this.establishments = await this.establecimientosService.getEstablishmentsPorOrganizacionTipoComprobanteData("retenciones");

        this.tiposRetenciones = await this.comprobantesService.getTiposImpuestosData();
        this.retenciones = await this.comprobantesService.getTiposRetencionesIVAData();
        //this.codigosRetenciones = await this.comprobantesService.getTiposComprobantesData();
        this.tiposComprobantes = await this.comprobantesService.getTiposComprobantesData();

        //Cargar datos de la factura
        //Cargar customer
        if (this.retencion && this.retencion.subjectCustomer) {
            this.subjectCustomer = this.retencion.subjectCustomer;
            this.retencion.subjectCustomer = new SubjectCustomer();
        }

        //Cargar details
        if (this.retencion && this.retencion.details && this.retencion.details.length > 0) {
            this.details = this.retencion.details ? this.retencion.details : [];
        }

        //Cargar emissionPoint y establishment
        if (this.retencion && this.retencion.emissionPoint && this.retencion.emissionPoint.id) {
            let estab: Establishment = this.establishments.find((item) => item.id == this.retencion.emissionPoint.establishmentId);
            if (estab && estab.id) {
                this.establishment = estab;
                if (this.establishment.emissionPoints && this.establishment.emissionPoints.length > 0) {
                    let point: EmissionPoint = this.establishment.emissionPoints.find((item) => item.id == this.retencion.emissionPoint.id);
                    this.emissionPointSelected = point ? point : new EmissionPoint();
                }
            }
        }

        //Cargar emissionPoint si es nueva factura
        /*if (!this.retencion || !this.retencion.id) {
            let estab: Establishment = (this.establishments && this.establishments.length > 0) ? this.establishments[0] : new Establishment();
            this.emissionPointSelected = (estab && estab.emissionPoints && estab.emissionPoints.length > 0) ? estab.emissionPoints[0] : new EmissionPoint();
        }*/

        //Validar campos para reenvío POSTED
        if (this.retencion && this.retencion.internalStatus && this.retencion.internalStatus == 'POSTED') {
            if (!this.formMainValid()) {
                this.ui.mostrarMensaje("warn", `${this.appConfig.ux.formIvalid}. No podrá emitir esta retención debido a que falta información importante no modificable. 
                Le recomendamos que realice una nueva retención.`);
            }
        }

        //Cargar campos adicionales de la organización
        this.camposAdicionales = []; //Encerar opciones.
        const campoAdicional = this.currentUser.organization.campoAdicional;
        const splits = campoAdicional && campoAdicional.length > 0 ? campoAdicional.split(",") : [];
        let index = 0;
        splits.forEach(campo => {
            this.camposAdicionales.push({ name: 'Campo' + index, type: 'text', value: null, label: campo })
            index++;
        });
        this.cargandoDataInit = false;
    }

    confirmarRetencion(event) {
        this.ui.limpiarMessages();
        if (this.currentUser.tieneCertificadoDigital) {
            //Ventana de confirmación
            let mensaje = this.appConfig.ux.confirmEnvioFacturaDesarrollo;
            if (this.currentUser.organization.ambientePro) {
                mensaje = this.appConfig.ux.confirmEnvioFacturaProduccion;
            }
            this.confirmationService.confirm({
                message: mensaje,
                accept: () => {
                    this.guardarRetencion(event);
                },
            });
        } else {
            let header = "¡Suscríbase a " + this.appConfig.app.name + "!";
            let body = `Registre su certificado de firma electrónica llamando al ${environment.settings.app.contact.phone} o escribiendo a ${environment.settings.app.contact.email}.`;
            let type = "error";
            this.resultData = { header: header, body: body, type: type, subErrors: null };
            this.resultDataButtons = [];
            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
            this.mostrarResultData = true;
        }
    }

    formMainValid() {
        let valido: boolean = true;
        if (!this.subjectCustomer
            || !this.subjectCustomer.customerCode
            || !(validateDni(this.subjectCustomer.customerCode)
                || validateRUC(this.subjectCustomer.customerCode))) {
            this.ui.mostrarMensaje("error", `${this.appConfig.validationMsgs.cirucCustomerInvalid}`);
            valido = false;
        } else if (!this.retencion || !this.subjectCustomer || !this.details) {
            valido = false;
        } else if (this.retencion && this.retencion.direccion === '') {
            valido = false;
        } else if (this.retencion && (!this.destinatarios || this.destinatarios.length == 0)) {
            valido = false;
        } else if (this.emissionPointSelected.id == null) {
            valido = false;
        }
        return valido;
    }

    async guardarRetencion(event) {
        this.ui.limpiarMessages();

        if (!this.formMainValid()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}`);
        } else {
            this.procesando = true;
            this.subjectCustomer.customerPhoto = "";//remover foto
            //Establecer valores UX
            this.retencion.details = this.details; //Los detalles de la factura
            this.retencion.subjectCustomer = this.subjectCustomer;
            //this.retencion.emissionOn = this.retencion.emissionOn ? this.retencion.emissionOn : new Date();

            if (this.retencion && this.retencion.internalStatus && (this.retencion.internalStatus == 'POSTED' || this.retencion.internalStatus == 'CREATED' || this.retencion.internalStatus == 'REJECTED')) {
                this.retencion.accionSRI = "enviar"; //Sólo enviar-autorizar-notificar al SRI
            } else {
                this.retencion.accionSRI = "emitir"; //Crear-enviar-autorizar-notificar
            }

            this.retencion.enviarSRI = true;
            this.retencion.ptoEmi = this.emissionPointSelected.name;
            this.retencion.estab = this.establishments.find((item) => item.id == this.emissionPointSelected.establishmentId).name;
            
            if (this.destinatarios && this.destinatarios.length > 0) {
                this.retencion.destinatarios = this.destinatarios;
            }
            
            let header = "";
            let body = "";
            let type = "";
            let subErrors: VeronicaApiSubErrorData = null;
            
            //Guardar la factura en persistencia para luego recargar las facturas
            this.comprobantesService.enviarRetencion(this.retencion).subscribe(
                async (data) => {
                    const entidad = "Retención"
                    if (data['success'] && data['success'] == true && data['result']) {
                        let dataResult = data['result'];
                        let regresaComprobante: boolean = dataResult['comprobantes'] && Array.isArray(dataResult['comprobantes']) && dataResult['comprobantes'].length > 0;
                        const comprobantes = dataResult['comprobantes'];
                        if (regresaComprobante && dataResult['estado'] == 'APPLIED') {
                            //const mensajeSRI = comprobantes[0]['mensajes'][0]['mensaje'];
                            header = this.appConfig.ux.messages.success + ` ${entidad} Autorizada por el SRI`;
                            body = `La ${entidad} fue autorizada por SRI y se notificó al cliente.`;
                            type = "success"
                        } else if (regresaComprobante && dataResult['estado'] != 'APPLIED') {
                            const mensajeSRI = comprobantes[0]['mensajes'][0]['mensaje'];
                            header = this.appConfig.ux.messages.error + ` ${entidad} devuelta por el SRI`;
                            body = `La ${entidad} fue recibida por SRI, pero no fue autorizada. Se marcó con el estado: ${dataResult['estado']}. El SRI respondió: ${mensajeSRI}`;
                            type = "error"
                        } else if (!regresaComprobante && dataResult['estado'] == 'APPLIED') {
                            header = this.appConfig.ux.messages.success + ` ${entidad} AUTORIZADA por el SRI`;
                            body = `La ${entidad} fue autorizada por SRI y se notificó al cliente.`;
                            type = "success"
                        } else {
                            header = this.appConfig.ux.messages.warn + ` ${entidad} devuelta por el SRI`;
                            body = `La ${entidad} fue recibida por SRI, pero no fue autorizada. Se marcó con el estado: ${dataResult['estado']}.`;
                            type = "warn"
                        }

                        //Mostar el resultado
                        this.resultData = { header: header, body: body, type: type, subErrors: null };
                        this.procesando = false;
                        this.resultDataButtons = [];
                        if (dataResult['estado'] == 'APPLIED') {
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonNuevaFactura);
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonVerListado);
                        } else {
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
                        }
                        this.mostrarResultData = true;
                        //this.fazilService.irAInicio();
                    } else if (data['success'] && data['success'] == false && data['errors']) {
                        this.resultDataButtons = [];
                        let dataError = data['errors'];
                        if (dataError['type'] == 'error-plan') {
                            header = dataError['message'].split('.')[0];
                            body = dataError['message'] ? dataError['message'].substring(dataError['message'].indexOf('.') + 1) : environment.settings.errorMsgs.error500;
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonStatic);
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonSuscription);
                        } else {
                            header = this.appConfig.ux.messages.error;
                            body = dataError['message'] ? dataError['message'] : environment.settings.errorMsgs.error500_SRI;
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
                        }
                        type = dataError['type'] ? dataError['type'] : 'error';
                        this.resultData = { header: header, body: body, type: type, subErrors: null };
                        this.procesando = false;
                        this.mostrarResultData = true;
                    } else if (data['errors']) {
                        this.resultDataButtons = [];
                        let dataError = data['errors'];
                        if (dataError['type'] == 'error-plan') {
                            header = dataError['message'].split('.')[0];
                            body = dataError['message'] ? dataError['message'].substring(dataError['message'].indexOf('.') + 1) : environment.settings.errorMsgs.error500;
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonStatic);
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonSuscription);
                        } else {
                            header = this.appConfig.ux.messages.error;
                            body = dataError['message'] ? dataError['message'] : environment.settings.errorMsgs.error500_SRI;
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
                        }
                        type = dataError['type'] ? dataError['type'] : 'error';
                        this.resultData = { header: header, body: body, type: type, subErrors: null };
                        this.procesando = false;
                        this.mostrarResultData = true;
                    }
                },
                async (err) => {
                    header = this.appConfig.ux.messages.error;
                    type = this.appConfig.ux.messagesType.error;
                    if (err['errors']) {
                        body = (err && err["errors"]["message"]) ? err["errors"]["message"] : environment.settings.errorMsgs.error500;
                        subErrors = err["errors"]["payload"]["errors"]["payload"]["subErrors"];
                    } else {
                        body = (err && err["message"]) ? err["message"] : environment.settings.errorMsgs.error500;
                    }
                    this.resultData = { header: header, body: body, type: type, subErrors: subErrors };
                    this.resultDataButtons = [];
                    this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
                    this.procesando = false;
                    this.mostrarResultData = true;
                }
            );
        }
    }

    resetVariablesSubjects(): void {
        this.ui.limpiarMessages();
        this.mostrarEditorSubject = false;
        this.subject = new Subject();
    }

    nuevoContacto() {
        this.resetVariablesSubjects();
        this.mostrarEditorSubject = true;
    }

    formSubjectCustomerCompleto() {
        return this.subjectCodeValid;
    }

    async guardarContacto() {
        this.ui.limpiarMessages();
        if (!this.formSubjectCustomerCompleto()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}`);
        } else {
            //Establecer valores UX
            this.subject.photo = null;
            this.subjectCustomer.customerPhoto = null;
            this.subjectCustomer.customer = this.subject;
            //Guardar subjectCustomer en persistencia
            this.contactosService.enviarContacto(this.subjectCustomer).subscribe(
                async (data) => {
                    this.subjectCustomer = data;
                    this.cargarDataSubjectCustomer(true, this.subjectCustomer, this.subjectCustomer.customerCodeType == 'CEDULA');
                    //Contactos
                    this.mostrarEditorSubject = false;
                    this.mostrarPopupSubjectCustomers = false;
                    this.ui.mostrarMensaje("success", `${this.subjectCustomer.customerFullName} ha sido registrad@ con éxito.`);
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        }
    }

    resetVariablesProducts(): void {
        this.ui.limpiarMessages();
        this.mostrarEditorProduct = false;
        this.product = new Product();
    }

    formProductCompleto() {
        return true;
    }

    activePopupSubjectCustomers(event) {
        this.mostrarPopupSubjectCustomers = true;
    }

    async filteredSubjectCustomerByKeyword(event) {
        this.processFilter = true;
        this.subjectCode = "";
        if (event && event.target && event.target.value && event.target.value.length > 3) {
            this.subjectCode = event.target.value.toLocaleLowerCase();
            this.pageOptions = { page: 0, pageSize: 999, filter: this.subjectCode, orderBy: 'name', order: 'ASC' };
            const page = await this.contactosService.getContactosPorUsuarioConectadoData(this.pageOptions);
            this.subjectCustomersFiltered = page['content'];
        }
    }

    async searchSubjectPorCode(event) {
        this.ui.limpiarMessages();
        this.subjectCodeValid = false;
        let code: string = this.subjectCode ? this.subjectCode.toString() : "";

        if (!code || code.length == 0) {
            return;
        }

        let isRUC: boolean = false;
        let isCI: boolean = false;

        if (code && code.length == 10) {
            isCI = validateDni(code);
        } else if (code && code.length == 13) {
            isRUC = validateRUC(code);
        }

        if (isCI || isRUC) {

            this.subjectCodeValid = true;

            let msg = "Verificando " + (isCI ? 'CI' : isRUC ? 'RUC' : '') + " Nº. " + code;
            this.verificandoData = this.ui.buildResultFromVerify(msg, this.appConfig.ux.messagesType.success);
            this.verificando = true;

            //Buscar si existe un usuario con ese code
            let data = await this.contactosService.getContactoPorCodeYUsuarioConectadoData(code);
            if (data && data['uuid']) {
                this.subject = data;
                this.ui.mostrarMensaje("info", `¡Está casi listo tu contacto ${this.subject.initials} para ${this.appConfig.app.name}!.`);
                this.verificando = false;
            } else {
                this.subject = new Subject();
                this.subject.code = this.subjectCode;
                this.verificando = false;
            }
        } else {
            this.subject = new Subject();
            this.verificando = false;
            this.ui.mostrarMensaje("error", `${this.appConfig.validationMsgs.cirucCustomerInvalid}`);
        }
    }


    async searchEmailByCode(event) {
        this.ui.limpiarMessages();
        this.emailValid = false;
        let code: string = this.subject.email ? this.subject.email : "";

        if (!code || code.length == 0) {
            return;
        }

        let msg = "Verificando email " + code;
        this.verificandoData = this.ui.buildResultFromVerify(msg, this.appConfig.ux.messagesType.success);
        this.verificando = true;

        if (code) {
            let emailExistente = false;

            this.emailValid = validateEmail(code);

            if (this.emailValid) {
                emailExistente = await this.administracionService.getEmailPorCodeData(code);
                this.verificando = false;
            } else {
                this.verificando = false;
                this.ui.mostrarMensaje("error", this.appConfig.validationMsgs.emailPattern);
                return;
            }
            if (emailExistente) {
                this.ui.mostrarMensaje("warn", `El correo electrónico ya se encuentra registrado.`);
            }
        } else {
            this.verificando = false;
        }
    }

    cargarDataSubjectCustomer(event, item: SubjectCustomer, facturarSoloCedula: boolean) {
        console.log('cargarDataSubjectCustomer ');
        this.ui.limpiarMessages();
        if (item) {
            this.subjectCustomer = item;
            if (facturarSoloCedula && item.esPersonaNatural) { //Sobreescribe el código y tipo que llega al backend
                this.subjectCustomer.customerCode = item.nui;
                this.subjectCustomer.customerCodeType = 'CEDULA';
            }
            this.retencion.direccion = this.subjectCustomer.customerDireccion;
            this.destinatarios.push(this.subjectCustomer.customerEmail);
            this.filteredDestinatarios();
            this.mostrarPopupSubjectCustomers = false;
        }
    }

    async filteredProductByKeyword(event) {
        this.processFilter = true;
        this.productsFiltered = this.ui.filteredListByField(this.products, 'name', event.target.value);
        this.processFilter = false;
    }

    ejecutarAccionResult(event, accion: string, item: any) {
        this.ui.limpiarMessages();
        if (accion == this.appConfig.ux.actionsExecute.close) {
            this.mostrarResultData = false;
        } else if (accion == 'nueva') {
            this.mostrarResultData = false;
            this.fazilService.irARetencion();
        } else if (accion == 'listado') {
            this.mostrarResultData = false;
            this.fazilService.irAInicioRetenciones();
        } else {
            this.ui.ejecutarAccionResultFromData(event, accion);//Acciones generales
        }
    }

    camposAdicionalesValidos(): boolean {
        let isValid: boolean = true;
        if (!this.camposAdicionales || (this.camposAdicionales && this.camposAdicionales.length == 0)) {
            isValid = true;
        } else {
            this.camposAdicionales.forEach((item) => {
                if (!item['value'] || item['value'] == undefined || item['value'] == null) {
                    isValid = false;
                }
            });
        }

        return isValid;
    }

    filteredDestinatarios() {
        this.filtered = this.destinatarioCtrl.valueChanges.pipe(
            startWith(null),
            map((destinatario: string | null) => (destinatario ? this._filterDestinatario(destinatario) : this.destinatariosAll.slice())),
        );
    }

    private _filterDestinatario(value: string): string[] {
        const filterValue = value.toLowerCase();
        //return this.destinatariosAll.filter(val => val.toLowerCase().includes(filterValue));
        return this.destinatariosAll.filter(val => val.toLowerCase().indexOf(filterValue) === 0);
    }

    agregarDestinatario(event: MatChipInputEvent): void {

        const input = event.input;
        const value = (event.value || '').trim();

        // Añadir nuestro destinatario
        if (value) {
            const isOptionSelected = this.matAutocomplete.options.some(option => option.selected);
            if (!isOptionSelected && validateEmail(value.trim())) {//Validar si es email
                this.destinatarios.push(value.trim());
            }
        }

        // Limpiar el input
        if (input) {
            input.value = '';
        }

        this.destinatarioCtrl.setValue(null);
    }

    agregarDestinatarioBlur(event: FocusEvent): void {
        const target: HTMLElement = event.relatedTarget as HTMLElement;
        if (!target || target.tagName !== 'MAT-OPTION') {
            const matChipEvent: MatChipInputEvent = { input: this.destinatarioInput.nativeElement, value: this.destinatarioInput.nativeElement.value };
            this.agregarDestinatario(matChipEvent);
        }
    }

    removerDestinatario(value: string): void {
        const index = this.destinatarios.indexOf(value);
        if (index >= 0) {
            this.destinatarios.splice(index, 1);
        }
    }

    selectedDestinatario(event: MatAutocompleteSelectedEvent): void {
        event.option.deselect();
        this.destinatarios.push(event.option.viewValue);
        this.destinatarioInput.nativeElement.value = '';
        this.destinatarioCtrl.setValue(null);
    }

    filtrarRetencionTipoDocumentoIdentidad(event) {
        this.filtrados = this.ui.filteredAutocomplete(this.tiposDocumentosIdentidad, 'description', event.query);
    }


    /**
    * Agrega un detalle de retención
    */
    mostrarRetencionDetalle() {
        this.detail = new RetencionDetalle();
        this.detail.indice = this.details.length + 1;
        this.detail.tipoImpuesto = this.tiposRetenciones[0]; //Tomar el primero
        this.detail.retencion = this.retenciones[0]; //Tomar el primero
        this.detail.porcentaRetencion = this.retenciones[0].factor; //Tomar el primero
        this.detail.tipoComprobante = this.tiposComprobantes[0]; //Tomar el primero
        this.mostrarPopupDetalleRetencion = true;
    }


    agregarDetalle() {
        this.detail.codigoTipoImpuesto = this.detail.tipoImpuesto.code;
        this.detail.codigoTipoRetencion = this.detail.retencion.code;
        this.detail.tipoDocumentoSustento = this.detail.tipoComprobante.code;

        this.details.push(this.detail);
        this.mostrarPopupDetalleRetencion = false;
        this.exitenDetallesSeleccionados = this.details.length > 0;
    }

    quitarDetalle() {
        this.exitenDetallesSeleccionados = this.details.length > 0;
    }

    calcularMontoRetenido(event: any) {
        this.detail.montoRetenido = this.detail.baseImponible * (this.detail.porcentaRetencion / 100);
    }

    actualizarPorcentajeRetencion(event: any) {

        //Si no hay asignar zero
        this.detail.porcentaRetencion = this.detail.retencion == null ? 0 : this.detail.retencion.factor;

        this.calcularMontoRetenido(event);
    }

    removerDetalle(indice: number) {
        this.details = this.details.filter(item => item.indice !== indice);
    }

    handleChangeEsCedulaDiferenteAlRUC(event) {
        this.subject.nui = '';
    }

    handleChangeEsPersonalNatural(event) {
        const checked = event.checked;
        if (checked) {
            this.subject.subjectType = 'NATURAL';
        } else {
            this.subject.subjectType = 'JURIDICA';
        }
    }
    /**
    * Manejo del evento del componente buscador de contactos, 
    * bien sea por selección o por creación de contacto
    */
    handleContactoSeleccionado(subjectCustomerOutput:SubjectCustomerOutput){
        this.mostrarPopupSubjectCustomers = false;
        if (subjectCustomerOutput.success){
            const esCedula:boolean = (subjectCustomerOutput.mode == "cedula");
            this.cargarDataSubjectCustomer(null, subjectCustomerOutput.data, esCedula);
        }   
    }
    
    asignarPuntoEmision(pem:EmissionPoint){
        this.emissionPointSelected = pem;
    }

}
